var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourbes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 20.4H3.09998V20.9H3.59998V20.4ZM10.8 9.6L11.2 9.3C11.1026 9.17018 10.9483 9.09569 10.7861 9.10019C10.6239 9.10469 10.474 9.18763 10.384 9.32265L10.8 9.6ZM14.4 14.4L14 14.7C14.0956 14.8275 14.2464 14.9018 14.4058 14.9C14.5652 14.8981 14.7142 14.8203 14.8068 14.6906L14.4 14.4ZM3.09998 3V20.4H4.09998V3H3.09998ZM3.59998 20.9H21V19.9H3.59998V20.9ZM6.416 17.0773L11.216 9.87735L10.384 9.32265L5.58395 16.5226L6.416 17.0773ZM10.4 9.9L14 14.7L14.8 14.1L11.2 9.3L10.4 9.9ZM14.8068 14.6906L20.8068 6.29062L19.9931 5.70938L13.9931 14.1094L14.8068 14.6906Z",
    fill: "#E01A4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourbes);
export default __webpack_public_path__ + "static/media/courbes.16090ee934461a33b881c2bdecc9ab2c.svg";
export { ForwardRef as ReactComponent };